const { render } = wp.element;

import Dashboard from './dashboard';

const Core = () => {

	// Debugging mode: add a function to track the next token refresh
	if ( meowAnalytics.debug_mode ) {
		meowAnalytics.getNextRefresh = () => {
			const now = (new Date()).getTime() / 1000;
			const seconds = meowAnalytics.expires_at - now;
			const minutes = Math.round(seconds / 60);
			if ( minutes > 0 )
				return (`Meow Analytics: ${minutes}mn left before next token refresh.`);
			else if ( seconds > 0 )
				return (`Meow Analytics: ${seconds}s left before next token refresh.`);
			else
				return (`Meow Analytics: The token has expired, and wasn't refreshed,`, seconds);
		};
	}

	return ( <Dashboard /> );
}

document.addEventListener('DOMContentLoaded', function(event) {
	let container = document.getElementById('meow-analytics-container');
	if (container) {
		render((<Core />), container);
	}
});
